export default __webpack_public_path__ + "static/media/securityCamera.102dc0e8.svg";